import { Component } from "react";

// Around a React.lazy part: if its chunk does not download (the network dropped, or a deploy
// replaced the files while this page stayed open), or it fails to render, a reload prompt
// takes its place - the error would otherwise unmount the whole app. React keeps a failed
// lazy() import for good, so only a page reload can fetch it again.
export class LazyBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("[LazyBoundary] a lazily loaded part failed:", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className={`flex flex-col items-center justify-center gap-2 p-4 text-center text-sm ${this.props.className ?? ""}`}>
        <p>This part of the page couldn't load.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="px-3 py-1.5 rounded-md border border-current text-xs font-medium hover:opacity-80"
        >
          Reload page
        </button>
      </div>
    );
  }
}
